<template>
  <b-card no-body class="h-100">
    <b-card-header>
      <b-card-title>Telegram-каналы</b-card-title>
      <small v-if="telegram && telegram.collected_on" class="text-muted">на {{ formatDate(telegram.collected_on) }}</small>
    </b-card-header>
    <b-card-body class="pt-0">
      <div v-if="!own && !competitors.length" class="text-center text-muted py-2">
        Данных пока нет — команда <code>telegram:collect-channel-stats</code> ещё не отработала
      </div>
      <template v-if="own">
        <div class="d-flex align-items-end justify-content-between">
          <div>
            <h2 class="mb-0 font-weight-bolder">{{ formatNumber(own.subscribers) }}</h2>
            <small class="text-muted">подписчиков @{{ own.username }}</small>
          </div>
          <div class="text-right">
            <b-badge :variant="`light-${deltaVariant(own.delta_7d)}`" class="mb-25">{{ formatDelta(own.delta_7d, '') }} за 7 дн.</b-badge><br>
            <b-badge :variant="`light-${deltaVariant(own.delta_30d)}`">{{ formatDelta(own.delta_30d, '') }} за 30 дн.</b-badge>
          </div>
        </div>
        <vue-apex-charts v-if="own.series && own.series.length > 1" type="area" height="90" :options="sparkOptions" :series="sparkSeries" />
      </template>
      <div v-if="competitors.length" class="mt-1">
        <small class="text-uppercase text-muted font-weight-bold">Конкуренты</small>
        <div v-for="item in competitors" :key="item.username" class="d-flex justify-content-between font-small-3 py-25 border-bottom">
          <b-link :href="`https://t.me/${item.username}`" target="_blank" rel="noopener noreferrer">@{{ item.username }}</b-link>
          <span>
            <span class="font-weight-bold">{{ formatNumber(item.subscribers) }}</span>
            <span :class="`text-${deltaVariant(item.delta_7d)} ml-50`">{{ formatDelta(item.delta_7d, '') }}</span>
          </span>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BBadge, BLink,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { computed } from '@vue/composition-api'
import { $themeColors } from '@themeConfig'
import { areaChartOptions } from '@core/components/statistics-cards/chartOptions'
import {
  formatNumber, formatDelta, deltaVariant, formatDate,
} from '@/views/dashboard/sifnf/utils'

export default {
  components: {
    BCard, BCardHeader, BCardTitle, BCardBody, BBadge, BLink, VueApexCharts,
  },
  props: {
    telegram: { type: Object, default: null },
  },
  setup(props) {
    const own = computed(() => (props.telegram && props.telegram.own) || null)
    const competitors = computed(() => (props.telegram && props.telegram.competitors) || [])

    const sparkSeries = computed(() => [{ name: 'подписчики', data: own.value ? own.value.series.map(point => point.subscribers) : [] }])
    const sparkOptions = computed(() => {
      const options = JSON.parse(JSON.stringify(areaChartOptions))
      options.theme.monochrome.color = $themeColors.info
      options.xaxis = { categories: own.value ? own.value.series.map(point => formatDate(point.date)) : [] }
      options.tooltip = { ...(options.tooltip || {}), x: { show: true } }
      return options
    })

    return {
      own, competitors, sparkSeries, sparkOptions, formatNumber, formatDelta, deltaVariant, formatDate,
    }
  },
}
</script>
